import React from "react";
import { Box } from "@mui/material";
import ServiceLocationRow from "./ServiceLocationRow";
import styles from "../AddVendorModal.module.css";
import { SERVICE_LOCATION_TITLE } from "../../../constants/addVendorModal.constants";

const ServiceLocationsStep = ({
  serviceLocations,
  stateOptions,
  getCityOptions,
  subProductOptions,
  showAdvanced,
  locationErrors,
  locationLoadError,
  onFieldChange,
  onRemove,
}) => (
  <Box>
    <Box className={styles.serviceHeader}>
      <Box className={styles.serviceHeaderTitle}>{SERVICE_LOCATION_TITLE}</Box>

      <Box className={styles.serviceHeaderRequired}>*</Box>
    </Box>

    {locationLoadError && (
      <Box className={styles.locationLoadError}>{locationLoadError}</Box>
    )}

    <Box className={styles.locationList}>
      {serviceLocations.map((location, index) => (
        <ServiceLocationRow
          key={index}
          index={index}
          location={location}
          stateOptions={stateOptions}
          cityOptions={getCityOptions(location.state)}
          subProductOptions={subProductOptions}
          showAdvanced={showAdvanced}
          locationErrors={locationErrors}
          onFieldChange={onFieldChange}
          onRemove={onRemove}
        />
      ))}
    </Box>
  </Box>
);

export default ServiceLocationsStep;
